module.exports = __webpack_public_path__ + "img/term.59ca1cf5.svg";